import {
  AlertCircle,
  Box,
  CheckCircle2,
  ClipboardList,
  Code2,
  Rocket,
} from "lucide-react";

const STEPS = [
  { icon: AlertCircle, label: "Business Problem", artifact: "Problem statement" },
  { icon: ClipboardList, label: "Requirements", artifact: "BRD · Functional requirements" },
  { icon: Box, label: "Product Definition", artifact: "PRD · User journeys" },
  { icon: Code2, label: "Development", artifact: "User stories · Product backlog" },
  { icon: CheckCircle2, label: "UAT", artifact: "Test cases · Acceptance criteria" },
  { icon: Rocket, label: "Product", artifact: "Release-ready product" },
];

export default function PipelineVisual() {
  return (
    <div
      data-testid="hero-pipeline-visual"
      className="relative rounded-2xl border border-navy/15 bg-white p-6 md:p-8"
    >
      <div className="flex items-center justify-between border-b border-navy/10 pb-4">
        <p className="text-[11px] font-medium uppercase tracking-[0.2em] text-navy/60">
          Idea → Product pipeline
        </p>
        <span className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.2em] text-navy/60">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-rust" />
          Flow
        </span>
      </div>

      <div className="relative mt-7">
        <div
          className="absolute bottom-5 left-[19px] top-5 w-px overflow-hidden"
          aria-hidden="true"
        >
          <div className="pipeline-line h-[calc(100%+12px)] w-px" />
        </div>
        <ol className="relative space-y-5">
          {STEPS.map((step, i) => {
            const isLast = i === STEPS.length - 1;
            return (
              <li key={step.label} className="flex items-center gap-4">
                <span
                  className={`z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border ${
                    isLast
                      ? "border-rust bg-rust text-white"
                      : "border-navy/20 bg-cream text-navy"
                  }`}
                >
                  <step.icon className="h-4 w-4" strokeWidth={1.5} />
                </span>
                <div className="flex min-w-0 flex-1 flex-wrap items-baseline justify-between gap-x-4">
                  <p className="text-sm font-semibold tracking-tight">
                    {step.label}
                  </p>
                  <p className="truncate text-xs text-navy/50">{step.artifact}</p>
                </div>
                <span className="hidden font-display text-sm text-navy/30 sm:block">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </li>
            );
          })}
        </ol>
      </div>

      <div className="mt-7 border-l-2 border-rust pl-4">
        <p className="text-xs leading-relaxed text-navy/60">
          Outcome — a development-ready product definition your team can build
          against with clarity.
        </p>
      </div>
    </div>
  );
}
